import { SearchOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Button, DatePicker, Input, Select } from 'antd';

import { MultipleSelect } from '@app/components';
import {
  PF,
  searchTypeOptions,
} from '@app/pages/Warehouses/WarehouseOperations/data';
import type {
  SearchType,
  FiltersType,
} from '@app/pages/Warehouses/WarehouseOperations/types';

const { RangePicker } = DatePicker;
const FILTER = `${PF}_filters`;

export const Filters: FiltersType = ({
  warehousesOptions,
  operationTypesOptions,
  productsOptions,
  disabled = false,
  values: { SearchTerm, SearchBy, range, warehouses, operationTypes, products },
  onFilterChange,
  onChangeSearchTerm,
  skipFilters,
  onSearch,
}) => (
  <div className={`${FILTER}_container`}>
    <RangePicker
      className={`${FILTER}_range`}
      value={range}
      onChange={(dates) => onFilterChange('range', dates)}
      format="DD.MM.YYYY"
      disabled={disabled}
    />

    <Input
      addonBefore={<SearchOutlined />}
      addonAfter={
        <Select<SearchType>
          value={SearchBy}
          options={searchTypeOptions}
          onChange={(value) => onFilterChange('SearchBy', value)}
          className={`${FILTER}_search-select`}
          disabled={disabled}
          popupMatchSelectWidth={false}
        />
      }
      placeholder="Введите название"
      value={SearchTerm}
      onChange={onChangeSearchTerm}
      className={`${FILTER}_search`}
      disabled={disabled}
      onPressEnter={onSearch}
    />

    <MultipleSelect
      className={`${FILTER}_select`}
      placeholder="Все склады"
      allOptions={warehousesOptions}
      selectedOption={warehouses}
      setSelectedOptions={(values) => onFilterChange('warehouses', values)}
      disabled={disabled}
    />

    <MultipleSelect
      className={`${FILTER}_select`}
      placeholder="Все операции"
      allOptions={operationTypesOptions}
      selectedOption={operationTypes}
      setSelectedOptions={(values) => onFilterChange('operationTypes', values)}
      disabled={disabled}
    />

    <MultipleSelect
      className={`${FILTER}_select`}
      placeholder="Все товары"
      allOptions={productsOptions}
      selectedOption={products}
      setSelectedOptions={(values) => onFilterChange('products', values)}
      disabled={disabled}
    />

    <div className={`${FILTER}_buttons`}>
      <Button
        htmlType="reset"
        onClick={skipFilters}
        className={`${FILTER}_buttons_item`}
        disabled={disabled}
      >
        <CloseCircleOutlined />
        Сброс
      </Button>
      <Button
        type="primary"
        onClick={onSearch}
        className={`${FILTER}_buttons_item`}
        disabled={disabled}
      >
        Показать
      </Button>
    </div>
  </div>
);
